<template>
  <div>
    <div class="px-4 pb-3">
      <v-btn style="float: right" @click="$emit('close')" icon>
        <v-icon>close</v-icon>
      </v-btn>

      <div style="font-size: 20px; font-weight: 600" class="pt-3 mb-3">
        {{ edittype == 'create' ? 'เพิ่ม' : 'แก้ไข' }}ข้อมูล IMEI
      </div>
      <div class="form-control">
        <v-layout class="pa-0 ma-0" wrap row
          ><v-flex xs12 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('Imei') }">
            <label>{{ $t('Imei') }}</label>
            <input
              :data-vv-as="$t('Imei')"
              v-validate="'required'"
              v-model="input.imei"
              :disabled="edittype == 'edit'"
              class="form-control"
              type="text"
              name="Imei"
            />
            <span class="text-error" v-if="errors.has('Imei')">{{ errors.first('Imei') }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('Coin ที่ได้รับ') }"
          >
            <label>{{ $t('Coin ที่ได้รับ') }}</label>
            <input
              :data-vv-as="$t('Coin ที่ได้รับ')"
              v-validate="'required'"
              v-model="input.points"
              class="form-control"
              type="number"
              name="Coin ที่ได้รับ"
            />
            <span class="text-error" v-if="errors.has('Coin ที่ได้รับ')">{{
              errors.first('Coin ที่ได้รับ')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm12
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('ข้อมูลเครื่อง') }"
          >
            <label>{{ $t('ข้อมูลเครื่อง') }}</label>
            <input
              :data-vv-as="$t('ข้อมูลเครื่อง')"
              v-validate="'required'"
              v-model="input.description"
              class="form-control"
              type="text"
              name="ข้อมูลเครื่อง"
            />
            <span class="text-error" v-if="errors.has('ข้อมูลเครื่อง')">{{
              errors.first('ข้อมูลเครื่อง')
            }}</span>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-btn @click="$emit('close')" outline color="grey">cancel</v-btn>
          <v-btn :loading="saveloading" @click="savedata" depressed color="primary">save</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: ['edittype', 'editdata'],
  data() {
    return {
      saveloading: false,
      input: {
        imei: '',
        description: '',
        points: ''
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    if (this.edittype == 'edit') {
      this.input = { ...this.editdata }
    }
  },
  methods: {
    async savedata() {
      if (await this.$validator.validateAll()) {
        if (this.edittype == 'create') {
          this.createdata()
        } else {
          this.editbranch()
        }
      }
    },
    editbranch() {
      var data = { pageid: this.selectedBot.pageid, ...this.input }
      this.saveloading = true
      api.updateYasaleImei(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onsave')
        }
      })
    },
    createdata() {
      var data = { pageid: this.selectedBot.pageid, ...this.input }
      this.saveloading = true
      api.createYasaleImei(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onsave')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/yasale/imei/ImeiEdit.vue